import(/* webpackMode: "eager" */ "/app/node_modules/@dxp-feed/google-map/dist/GoogleMap.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@dxp-feed/google-map/dist/GoogleMapsProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/storeDetail/StoreDetailPage.tsx");
